import { render, staticRenderFns } from "./selectModel.vue?vue&type=template&id=6aa60e75&"
import script from "./selectModel.vue?vue&type=script&lang=js&"
export * from "./selectModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports